import React from 'react';
import LinkButton from './LinkButton';
import styles from './NotFound.css';
import StaticNavigation from './StaticPages/StaticNavigation';

const NotFound = () => (
  <div>
    <StaticNavigation title="404" />
    <div className={styles.container}>
      <h1 className={styles.notFoundTitle}>
        We can&apos;t find the page you are looking for.
      </h1>
      <p className={styles.notFoundContent}>
        Click here to return to our homepage.
      </p>

      <LinkButton to="/" className={styles.button}>
        <span>Home</span>
      </LinkButton>
    </div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.jsx